
import { useAuthStore } from '../../stores/auth';
import { useSession } from '../../stores/session';
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import WalletWithdraw from '../../popup/WalletWithdraw.vue';
import PromotionList from '../../popup/PromotionList.vue';
import Contact from '../../popup/Contact.vue';
import Login from '../../popup/Login.vue';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import Register from '../../popup/Register.vue';

export default {
	name: 'IndexSubMenu',
	setup() {

		const auth = useAuthStore();
		auth.hydrate();

		const session = useSession();

		const btnClickWalletDeposit = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/bg-login.webp)] bg-size-[110%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:deposit');
			await showVuePopup(WalletDeposit, {});
		}

		const btnClickWalletWithdraw = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/bg-login.webp)] bg-size-[110%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:withdraw');
			await showVuePopup(WalletWithdraw, {});
		}

		const btnClickRegister = async () => {
			if (!auth.isLoggedIn) {
				await showVuePopup(Login, {}, {
					customClass: {
						popup: 'bg-[url(https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/bg-login.webp)] bg-size-[110%_100%] bg-center bg-transparent',
					},
				});
				return;
			}

			await showVuePopup(Register, {});
		}

		const btnClickContact = async () => {
			await showVuePopup(Contact);
		}

		return {
			btnClickWalletDeposit,
			btnClickWalletWithdraw,
			btnClickRegister,
			btnClickContact,
		}
	}
}
